module.exports = __webpack_public_path__ + "img/vessel-error-circle.263420b5.svg";